<div class="payment-status-container">
  <div class="status-card">
    <!-- Payment Image -->
    <div class="payment-image">
      <img src="/svg/paymentImage.svg" alt="Payment Status" />
    </div>

    <!-- Status Icon -->
    <div class="status-icon" [ngStyle]="{'color': getStatusColor()}">
      <i [class]="getStatusIcon()"></i>
    </div>

    <!-- Status Title -->
    <h1 class="status-title" [ngStyle]="{'color': getStatusColor()}">
      {{ getStatusTitle() }}
    </h1>

    <!-- Status Message -->
    <p class="status-message">{{ message }}</p>

    <!-- Success State -->
    <div *ngIf="status === 'success'" class="success-details">
      <div class="detail-item" *ngIf="orderId">
        <i class="fas fa-receipt"></i>
        <div class="detail-content">
          <span class="detail-label">Order ID:</span>
          <span class="detail-value">{{ orderId }}</span>
        </div>
      </div>

      <div class="detail-item" *ngIf="paymentId">
        <i class="fas fa-credit-card"></i>
        <div class="detail-content">
          <span class="detail-label">Payment ID:</span>
          <span class="detail-value">{{ paymentId }}</span>
        </div>
      </div>

      <div class="detail-item" *ngIf="amount > 0">
        <i class="fas fa-rupee-sign"></i>
        <div class="detail-content">
          <span class="detail-label">Amount Paid:</span>
          <span class="detail-value">₹{{ amount }}</span>
        </div>
      </div>

      <div class="success-note">
        <i class="fas fa-info-circle"></i>
        <p>You will receive an email confirmation shortly. You can track your order from the Orders page.</p>
      </div>

      <div class="action-buttons">
        <button class="btn btn-primary" (click)="goToHome()">
          <i class="fas fa-home"></i>
          Go to Home
        </button>
        <button class="btn btn-secondary" (click)="viewOrder()">
          <i class="fas fa-list"></i>
          View Orders
        </button>
      </div>
    </div>

    <!-- Failed State -->
    <div *ngIf="status === 'failed'" class="failed-details">
      <div class="error-message" *ngIf="errorMessage">
        <i class="fas fa-exclamation-triangle"></i>
        <p>{{ errorMessage }}</p>
      </div>

      <div class="failed-note">
        <i class="fas fa-info-circle"></i>
        <p>If the amount was deducted, it will be refunded within 5-7 business days.</p>
      </div>

      <div class="action-buttons">
        <button class="btn btn-primary" (click)="retryPayment()">
          <i class="fas fa-redo"></i>
          Try Again
        </button>
        <button class="btn btn-secondary" (click)="goToHome()">
          <i class="fas fa-home"></i>
          Go to Home
        </button>
        <button class="btn btn-outline" (click)="contactSupport()">
          <i class="fas fa-headset"></i>
          Contact Support
        </button>
      </div>
    </div>

    <!-- Cancelled State -->
    <div *ngIf="status === 'cancelled'" class="cancelled-details">
      <div class="error-message" *ngIf="errorMessage">
        <i class="fas fa-info-circle"></i>
        <p>{{ errorMessage }}</p>
      </div>

      <div class="action-buttons">
        <button class="btn btn-primary" (click)="retryPayment()">
          <i class="fas fa-shopping-cart"></i>
          Go to Cart
        </button>
        <button class="btn btn-secondary" (click)="goToHome()">
          <i class="fas fa-home"></i>
          Go to Home
        </button>
      </div>
    </div>

    <!-- Pending State -->
    <div *ngIf="status === 'pending'" class="pending-details">
      <div class="spinner"></div>
      <p class="pending-text">Please wait while we process your payment...</p>
    </div>
  </div>
</div>

